import AdminList from "@/admin/components/AdminList";

export default function BlogList() {
  return (
    <AdminList
      testId="admin-blog-list"
      title="Blog"
      kicker="Gestão de Conteúdo"
      resource="blog"
      createTo="/admin/blog/novo"
      editTo="/admin/blog"
      columns={[
        {
          key: "title", label: "Título",
          render: (p) => (
            <div className="flex items-center gap-3">
              {p.cover_image && <img src={p.cover_image} className="w-12 h-12 rounded-lg object-cover border border-[#2a2a2a]" alt="" />}
              <div>
                <div className="text-white font-medium">{p.title}</div>
                <div className="text-[10px] tracking-[0.2em] uppercase text-[#7d7d7d] mt-0.5">{p.slug}</div>
              </div>
            </div>
          ),
        },
        { key: "category", label: "Categoria" },
        { key: "author", label: "Autor" },
        { key: "date", label: "Data", render: (p) => p.date ? new Date(p.date + "T12:00:00").toLocaleDateString("pt-BR") : "—" },
      ]}
    />
  );
}
